module.exports = __webpack_public_path__ + "assets/img/18_1869_big.2cd08196.jpg";